import { Component, Input, OnChanges, OnInit } from '@angular/core'
import { LocaleCode } from 'src/app/interfaces/locale'
import { MbtiResultInput, MbtiType } from 'src/app/interfaces/mbti'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { ModalService } from 'src/app/services/modal/modal.service'
import { MbtiLinkPipe } from './../../../pipes/mbti-link.pipe'

interface PersonalityComparison {
  left: { type: 'E' | 'S' | 'T' | 'P'; name: string }
  right: { type: 'I' | 'N' | 'F' | 'J'; name: string }
}

@Component({
  selector: 'app-percent-stacked-bar',
  templateUrl: './percent-stacked-bar.component.html',
  styleUrls: ['./percent-stacked-bar.component.scss'],
  providers: [MbtiLinkPipe],
})
export class PercentStackedBarComponent implements OnInit, OnChanges {
  @Input() type: 'host' | 'guest' | undefined
  @Input() result: MbtiResultInput | undefined
  @Input() comparisonResult: MbtiResultInput | undefined
  @Input() firstName: string | undefined
  @Input() comparisonLabel:
    | {
        main: string
        comparison?: string
      }
    | undefined
  @Input() hideHeader = false
  @Input() isBarMbtiColor: boolean = false
  @Input() isCompareBarMbtiColor: boolean = false
  @Input() showEmptyCompareBar = false
  @Input() compareBarOpacity = 0.8
  @Input() showMbti = false
  mbtiType = MbtiType
  mainResult: MbtiResultInput | undefined
  mbtiCompareList: PersonalityComparison[] = [
    { left: { type: 'E', name: `mbti.common.dimensions.E` }, right: { type: 'I', name: `mbti.common.dimensions.I` } },
    { left: { type: 'S', name: `mbti.common.dimensions.S` }, right: { type: 'N', name: `mbti.common.dimensions.N` } },
    { left: { type: 'T', name: `mbti.common.dimensions.T` }, right: { type: 'F', name: `mbti.common.dimensions.F` } },
    { left: { type: 'P', name: `mbti.common.dimensions.P` }, right: { type: 'J', name: `mbti.common.dimensions.J` } },
  ]
  constructor(
    private personalityLinkPipe: MbtiLinkPipe,
    private modalService: ModalService,
    private localeService: LocaleService
  ) {}

  locale$ = this.localeService.locale$
  eLocaleCode = LocaleCode

  ngOnInit(): void {}
  ngOnChanges(): void {
    this.mainResult = this.result ?? this.comparisonResult
  }

  goToPersonalityDetail(): void {
    if (this.result?.mbti) {
      const link = this.personalityLinkPipe.transform(this.result.mbti)
      this.modalService.openExternalLink(link)
    }
  }

  get mbtiIconImage(): string {
    if (this.result) {
      return `assets/icons/mbti/no_background_mbti/${this.result.mbti}.png`
    }
    return ''
  }
}
